<script setup lang="ts">
import { Link } from '@inertiajs/vue3';
import { computed } from 'vue';

const props = defineProps({
    href: {
        type: String,
        default: '#',
    },
    label: {
        type: String,
        default: 'Not set',
    },
    removeWidth: Boolean,
    external: Boolean,
});

const component = computed(() => {
    return props.external ? 'a' : Link;
});
</script>

<template>
    <component
        :is="component"
        class="relative inline-flex items-center justify-center block px-4 py-2 text-center transition-colors border h-13 focus:outline-none focus:ring-2 focus:ring-offset-1 disabled:bg-gray-300 disabled:text-gray-700"
        :class="{
            'bg-primary text-white hover:bg-primary/80  focus:ring-primary border-white': true,
            'w-60': !removeWidth,
            'w-full': removeWidth,
        }"
        :target="props.external ? '_blank' : ''"
        :href="href"
    >
        {{ label }}
    </component>
</template>
